import { cached } from '@porotutu/react'
import { PendingPage, statusPagesFor } from '@porotutu/react/components/StatusPage/StatusPage'
import type { QueryClient } from '@tanstack/react-query'
import { createRoute, createRouter, redirect } from '@tanstack/react-router'
import { auditRoutes } from '../features/audit/route'
import { authRoutes } from '../features/auth/route'
import { campaignRoutes } from '../features/campaigns/route'
import { customerRoutes } from '../features/customers/route'
import { dashboardRoutes } from '../features/dashboard/route'
import { earningRuleRoutes } from '../features/earning_rules/route'
import { eventRoutes } from '../features/events/route'
import { jobRoutes } from '../features/jobs/route'
import { orderRoutes } from '../features/orders/route'
import { organizationRoutes } from '../features/organizations/route'
import { pointTransactionRoutes } from '../features/point_transactions/route'
import { productRoutes } from '../features/products/route'
import { profileRoutes } from '../features/profile/route'
import { redemptionRoutes } from '../features/redemptions/route'
import { rewardRoutes } from '../features/rewards/route'
import { segmentRoutes } from '../features/segments/route'
import { memberRoutes } from '../features/users/route'
import { validationRuleRoutes } from '../features/validation_rules/route'
import { voucherRoutes } from '../features/vouchers/route'
import { webhookSubscriptionRoutes } from '../features/webhook_subscriptions/route'
import { profileQuery } from '../session/profile'
import { HOME, rootRoute, signedInRoute } from './root'

const entryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: async ({ context }) => {
    const signedIn = (await context.queryClient.query(cached(profileQuery))) !== null

    throw redirect({ to: signedIn ? HOME.to : '/sign-in', replace: true })
  },
})

const routeTree = rootRoute.addChildren([
  entryRoute,
  ...authRoutes,
  signedInRoute.addChildren([
    ...dashboardRoutes,
    ...memberRoutes,
    ...organizationRoutes,
    ...auditRoutes,
    ...jobRoutes,
    ...customerRoutes,
    ...voucherRoutes,
    ...campaignRoutes,
    ...pointTransactionRoutes,
    ...orderRoutes,
    ...redemptionRoutes,
    ...eventRoutes,
    ...rewardRoutes,
    ...earningRuleRoutes,
    ...segmentRoutes,
    ...productRoutes,
    ...validationRuleRoutes,
    ...webhookSubscriptionRoutes,
    ...profileRoutes,
  ]),
])

const { ErrorPage, NotFoundPage } = statusPagesFor(HOME)

export const buildRouter = (queryClient: QueryClient) =>
  createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: ErrorPage,
    defaultNotFoundComponent: NotFoundPage,
    defaultPendingComponent: PendingPage,
  })

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof buildRouter>
  }
}
